import {AdminWidget} from "../../widget/AdminWidget";
import {ExperienceFormComponent} from "../../components/admin/ExperienceForm/ExperienceFormComponent";

export const ExperienceForm = () => {
    return(
        <AdminWidget>
            <ExperienceFormComponent />
        </AdminWidget>
    )
}